// extracted by mini-css-extract-plugin
export default {"addressItem":"addressItem---nt3go","addressItemContent":"addressItemContent---Bwvgq"};